import { render } from "./modal.vue?vue&type=template&id=1685279a&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=1685279a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1685279a"

export default script